import axios from "axios";
import { getStorage, setStorage } from "./storage";
import type { TLoginResponse } from "@/features/auth/types";
let refreshing_token: Promise<TLoginResponse | undefined> | undefined;

const API_URL = `${import.meta.env.VITE_SERVER_URI}`;
const MyAxios = axios.create({
  baseURL: API_URL,

  // withCredentials: true
});

MyAxios.interceptors.request.use((config) => {
  const { accessToken } = getStorage();

  !!accessToken && (config.headers["Authorization"] = "Bearer " + accessToken);
  // Get the preferred language from the browser
  const language = navigator.language;
  // const url =
  //   import.meta.env.MODE === "development"
  //     ? import.meta.env.VITE_CLIENTID
  //     : window.location.origin.replace("https://", "").split(".")?.[0];

  // Set the Accept-Language header
  config.headers["Accept-Language"] = language;
  // config.headers["clientid"] = url;

  return config;
});

async function onGetRefreshToken(): Promise<TLoginResponse | undefined> {
  const { refreshToken } = getStorage();

  try {
    const data = await axios.post<TLoginResponse>(
      `${import.meta.env.VITE_SERVER_URL}/v2/auth/refresh-token`,
      { refreshToken },
    );
    return data.data;
  } catch (error) {
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("access_token");
    localStorage.removeItem("company");
    localStorage.removeItem("mainOffice");

    localStorage.setItem(
      "redirectAfterLogin",
      window.location.pathname + window.location.search,
    );

    window.location.href = "/auth/login";
    return undefined;
  }
}

MyAxios.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalConfig = error.config;
    const errCode = error?.response?.status;
    if (errCode === 418) {
      window.location.href = "/auth/resetpasswd/force";
    } else if (errCode === 401 && !originalConfig._retry) {
      refreshing_token = refreshing_token ?? onGetRefreshToken();
      const responseJson = await refreshing_token;
      refreshing_token = undefined;

      if (!responseJson?.accessToken) {
        return Promise.reject(error);
      }

      const { setAccessToken, setRefreshToken } = setStorage();
      setAccessToken(responseJson.accessToken);
      setRefreshToken(responseJson.refreshToken ?? "");
      MyAxios.defaults.headers["Authorization"] =
        `Bearer ${responseJson.accessToken}`;
      originalConfig._retry = true;
      return MyAxios(originalConfig);
    } else {
      return Promise.reject(error);
    }
  },
);

export default MyAxios;
